<template>
    <div>
        <div class="text-center" style="min-height: calc(100vh - 110px); display: flex;">
            <div style="align-self: center; margin: 0 auto 7rem;">
                <cog-loader />
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>